import { StringService } from "@nuskin/ns-util";

import BUILT_IN_TRANSLATIONS from '../content/translations.json';

export
async function loadLocalization(app, locale) {
    const localizations = await loadMessagesForLocale(app, locale);
    return { ...BUILT_IN_TRANSLATIONS, ...localizations };
}

async function loadMessagesForLocale(app, locale) {
    if (!app || !locale) {
        return {};
    }
    try {
        return await StringService.getApplicationStrings(app, {}, locale);
    } catch (ex) {
        console.error(`Error loading localizations for "${locale}".`);
    }
}
